import type { EcommerceShopContext } from '../api/ecommerceAccounts';
import type { DemoWorkspace } from '../api/demoWorkspace';
import { isBuyingBusinessType } from './shopOverview';
import { getSystemShopId } from './shopContext';

export const PRODUCT_SELECTION_SELF_OPERATED_PATH = '/product-specialist';
export const PRODUCT_SELECTION_BUYING_PATH = '/product-selection/buying';

export function findCurrentShopContext(
  shopContexts: EcommerceShopContext[],
  currentShopId: string
) {
  const normalizedShopId = currentShopId.trim();
  if (!normalizedShopId) {
    return null;
  }

  return shopContexts.find((item) => getSystemShopId(item) === normalizedShopId) ?? null;
}

export function findEffectiveProductSelectionShopContext(
  shopContexts: EcommerceShopContext[],
  currentShopId: string,
  demoWorkspace?: DemoWorkspace | null
) {
  if (demoWorkspace?.shop) {
    return demoWorkspace.shop;
  }
  return findCurrentShopContext(shopContexts, currentShopId);
}

export function resolveProductSelectionPath(shop: EcommerceShopContext | null | undefined) {
  // 业务侧约定：自营商家进入测品链路，带货商家进入选品链路。
  // PRODUCT_SELECTION_BUYING_PATH 是历史路径名，当前承载的是飞瓜/Kimi 测品页面。
  return isBuyingBusinessType(shop?.business_type)
    ? PRODUCT_SELECTION_SELF_OPERATED_PATH
    : PRODUCT_SELECTION_BUYING_PATH;
}
